import React from 'react';
import EditButton from 'forms/components/EditButton';
import ReportFileForm from './ReportFileForm';
import PropTypes from 'prop-types';
export default function ReportFileEditButton({ organizations, ...props }) {
  return (
    <EditButton
      title='報表'
      form={(formProps) => <ReportFileForm {...formProps} organizations={organizations} />}
      {...props}
    />);
}

ReportFileEditButton.propTypes = {
  organizations: PropTypes.array,
};
